import { Organization } from "../organization";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterOrgSettingsEntityConfig } from "./config";
import { CallCenterOrgSettingsFilters } from "./filters";
import { CallCenterOrgSettingsMethods } from "./methods";

@HyperEntity<CallCenterOrgSettings>(
  "call-center-org-settings",
  CallCenterOrgSettingsEntityConfig,
)
export class CallCenterOrgSettings extends extender(
  CallCenterOrgSettingsFilters,
  CallCenterOrgSettingsMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({ dbName: "fixed_briefing", caption: "דגשים קבועים" })
  fixedBriefing = "";

  @Fields.string({ dbName: "rotating_notes", caption: "הערות מתחלפות" })
  rotatingNotes = "";

  @Fields.string({ dbName: "feed_link_url", caption: "קישור פיד" })
  feedLinkUrl = "";

  @Fields.string({ dbName: "feed_link_sms_text", caption: "טקסט SMS לקישור" })
  feedLinkSmsText = "";

  @Fields.integer({ dbName: "daily_goal_default", caption: "יעד יומי ברירת מחדל" })
  dailyGoalDefault = 8;

  @Fields.integer({ dbName: "daily_goal_cap", caption: "תקרת יעד" })
  dailyGoalCap = 40;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
